/** Pfade der Rechtstexte. Eigene kleine Datei, damit Fusszeile, Registrierung und Konto sie verlinken
 * koennen, ohne die Seite samt Texten (src/legal/*.json) ins Haupt-Bundle zu ziehen. */
export const LEGAL_PATHS = {
  terms: '/agb',
  privacy: '/datenschutz',
} as const;

export type LegalDocumentKind = keyof typeof LEGAL_PATHS;
